import pino from 'pino'
import { createWriteStream, createPinoBrowserSend } from 'pino-logflare'

const apiKey = process.env.NEXT_PUBLIC_LOGFLARE_API_KEY ?? ''
const sourceToken = process.env.NEXT_PUBLIC_LOGFLARE_SOURCE_ID ?? ''

const stream = createWriteStream({
  apiKey,
  sourceToken
})

const send = createPinoBrowserSend({
  apiKey,
  sourceToken
})

export const logger = pino(
  {
    browser: {
      transmit: {
        send: send as any
      }
    },
    level: 'debug',
    base: {
      env: process.env.NODE_ENV || 'NODE_ENV not set',
      revision: process.env.NEXT_PUBLIC_COMMIT_REF
    }
  },
  stream
)
